module.exports = __webpack_public_path__ + "img/invoices-o.3ac96ac4.svg";